import React, { useRef, useEffect } from "react";

const ImageCard = ({ image, title }) => (
  <div className="flex-shrink-0 w-[80%] sm:w-[60%] md:w-[40%] lg:w-[25%] snap-start">
    <img
      src={image}
      alt={title}
      className="w-full h-56 object-cover rounded-lg shadow-md"
    />
  </div>
);

const ImageCardsWithVerticalView = ({ verticalCards }) => {
  const carouselRef = useRef(null);

  // Auto-scroll setup (optional)
  useEffect(() => {
    const ref = carouselRef.current;
    let scrollInterval = setInterval(() => {
      if (!ref) return;
      const scrollWidth = ref.scrollWidth;
      const clientWidth = ref.clientWidth;
      const scrollLeft = ref.scrollLeft;

      const maxScroll = scrollWidth - clientWidth;
      if (scrollLeft < maxScroll) {
        ref.scrollTo({ left: scrollLeft + 200, behavior: "smooth" });
      } else {
        ref.scrollTo({ left: 0, behavior: "smooth" });
      }
    }, 4000);

    return () => clearInterval(scrollInterval);
  }, []);

  return (
    <div className="bg-white p-6 pt-0">
      <h1 className="text-2xl font-bold mb-6 text-center text-green-600">
        Experience Nature!
      </h1>

      <div
        className="flex overflow-x-auto space-x-4 scrollbar-hide snap-x snap-mandatory scroll-smooth px-2"
        ref={carouselRef}
      >
        {verticalCards.map((card, index) => (
          <ImageCard key={index} image={card.image} title={card.title} />
        ))}
      </div>
    </div>
  );
};

export default ImageCardsWithVerticalView;
